module.exports = __webpack_public_path__ + "static/contact_qr.de5f7f12.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/contact_qr.png
// module id = 307
// module chunks = 2